const VrsteKonstalacijaEs = () => {
    return (
        <>
            <div className="row">
                <div className="col-12">
                    <h2>Tipoj de konstelacioj</h2>
                    <p>La konstelacia metodo komence esti uzata por personaj kaj familiaj implikiĝoj.</p>
                    <p>
                        Baldaŭ oni rimarkis, ke la saamaj principoj de aparteno kaj ordo regas ankaŭ en aliaj sistemoj
                        kaj ke la sama metodo helpas. Tiel disvolviĝis sistemaj konstelacioj, komercaj konstelacioj,
                        astrologiaj konstelacioj ktp.. Multaj terapiistoj uzas bazajn konstelaciajn agordojn kaj ilojn
                        ene de siaj metodoj.
                    </p>
                </div>
            </div>
        </>
    );
};

export default VrsteKonstalacijaEs;
